import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
// Dev only: every error and Vue warning a page meets goes to logs/browser.log through the dev server
// (dev-tools/browser-log.js), from any browser that opens the dev server: the user's Chrome, the phone, the headless
// checks. The console still shows the errors. Test and production never run this (process.env.DEV).
// In Chrome's DevTools, console.error lines now point at this file: add it to the ignore list (Settings → Ignore
// list) to get the click-through to the real caller back.
import { Meteor } from 'meteor/meteor';
var ROUTE = process.env.BROWSER_LOG_ROUTE; // one value, set in quasar.conf.js from dev-tools/browser-log.js

var MAX_PER_MINUTE = 60; // a screen that keeps failing writes a minute's sample, not thousands of lines

var SAME_WITHIN_MS = 2000; // the same message again within this is counted once

var MAX_TEXT = 2000; // a message or a stack is cut here, so one entry stays small

var MAX_BATCH = 40 * 1024; // a send stays under the 64 KB that sendBeacon and the dev server accept

export default (function (_ref) {
  var Vue = _ref.Vue,
      router = _ref.router;
  if (!process.env.DEV || typeof window === 'undefined' || !ROUTE) return;
  var consoleError = console.error.bind(console);
  var queue = [];
  var timer = null;
  var minute = 0;
  var sentThisMinute = 0;
  var lastSeen = new Map(); // batches go one after the other with a plain fetch (sendBeacon and keepalive share one 64 KB budget for all
  // requests in flight, so several batches at once would be dropped); a closing page uses sendBeacon

  var sending = Promise.resolve();

  var post = function post(body) {
    return fetch(ROUTE, {
      method: 'POST',
      body: body,
      headers: {
        'Content-Type': 'text/plain'
      }
    }).catch(function () {});
  };

  var send = function send(body, closing) {
    if (closing) {
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(ROUTE, new Blob([body], {
          type: 'text/plain'
        }))) return;
      } catch (err) {
        /* fall through to fetch */
      }
    }

    try {
      sending = sending.then(function () {
        return post(body);
      });
    } catch (err) {
      /* reporting must never throw */
    }
  }; // the queue in batches under MAX_BATCH (each entry is already cut to MAX_TEXT)


  var flush = function flush(closing) {
    closing = closing === true;
    timer = null;
    var batch = [];
    var size = 2;
    queue.forEach(function (entry) {
      var length = JSON.stringify(entry).length + 1;

      if (batch.length && size + length > MAX_BATCH) {
        send(JSON.stringify(batch), closing);
        batch = [];
        size = 2;
      }

      batch.push(entry);
      size += length;
    });
    if (batch.length) send(JSON.stringify(batch), closing);
    queue = [];
  };

  var report = function report(kind, message, stack) {
    var now = Date.now();
    var text = String(message).slice(0, MAX_TEXT);
    var key = kind + text;
    if (lastSeen.has(key) && now - lastSeen.get(key) < SAME_WITHIN_MS) return;
    lastSeen.set(key, now);
    if (lastSeen.size > 200) lastSeen.forEach(function (at, k) {
      if (now - at >= SAME_WITHIN_MS) lastSeen.delete(k);
    });

    if (Math.floor(now / 60000) !== minute) {
      minute = Math.floor(now / 60000);
      sentThisMinute = 0;
    }

    if (++sentThisMinute > MAX_PER_MINUTE) return;
    queue.push({
      kind: kind,
      message: text,
      stack: stack ? String(stack).slice(0, MAX_TEXT) : '',
      page: router && router.currentRoute && router.currentRoute.fullPath || window.location.pathname,
      width: window.innerWidth,
      headless: !!navigator.webdriver
    });
    if (!timer) timer = setTimeout(flush, 500);
  }; // uncaught errors and promises nobody caught (suppress-errors.js runs first and keeps the ResizeObserver noise out)


  window.addEventListener('error', function (event) {
    report('error', event.message || event.error && event.error.message || 'error', event.error && event.error.stack);
  });
  window.addEventListener('unhandledrejection', function (event) {
    var r = event.reason;
    report('unhandled promise', textOf(r), r && r.stack);
  }); // errors inside components (a render, a watcher, a hook): Vue catches these itself, so they never reach window.
  // A handler replaces Vue's own printing, so this prints what Vue printed: the hook and the component

  var previousError = Vue.config.errorHandler;

  Vue.config.errorHandler = function (err, vm, info) {
    var where = componentName(vm);
    report('vue error', "".concat(textOf(err), " (").concat(info).concat(where ? ', in ' + where : '', ")"), err && err.stack);
    if (previousError) return previousError(err, vm, info);
    consoleError("[Vue warn]: Error in ".concat(info, ": \"").concat(textOf(err), "\"").concat(where ? '\n\nfound in ' + where : ''));
    consoleError(err);
  }; // Vue's warnings (a missing prop, a wrong type): with a handler set, Vue no longer prints them, so this does


  var previousWarn = Vue.config.warnHandler;

  Vue.config.warnHandler = function (msg, vm, trace) {
    report('vue warn', msg, trace);
    if (previousWarn) previousWarn(msg, vm, trace);else consoleError("[Vue warn]: ".concat(msg).concat(trace));
  }; // what the app and its libraries log as an error themselves (a Leaflet problem, a caught error printed)


  console.error = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    consoleError.apply(void 0, args);
    var first = args[0];
    if (typeof first === 'string' && first.startsWith('[Vue warn]')) return; // reported above

    var withStack = args.find(function (a) {
      return a && a.stack;
    });
    report('console.error', args.map(textOf).join(' '), withStack && withStack.stack);
  }; // Meteor prints its own exceptions (a method's callback that throws, a failed subscription) through Meteor._debug,
  // which uses console.log, not console.error


  if (Meteor && typeof Meteor._debug === 'function') {
    var meteorDebug = Meteor._debug;

    Meteor._debug = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var withStack = args.find(function (a) {
        return a && a.stack;
      });
      report('meteor', args.map(textOf).join(' '), withStack && withStack.stack);
      return meteorDebug.apply(this, args);
    };
  }

  window.addEventListener('pagehide', function () {
    return flush(true);
  });
}); // an Error's message, a string as it is, anything else as JSON (a Meteor error object, a rejected plain object)

var textOf = function textOf(value) {
  if (value && typeof value.message === 'string') return value.message;
  if (typeof value === 'string') return value;

  try {
    return JSON.stringify(value);
  } catch (err) {
    return String(value);
  }
};

var componentName = function componentName(vm) {
  if (!vm || !vm.$options) return '';
  var name = vm.$options.name || vm.$options._componentTag;
  var file = vm.$options.__file;
  return name ? "<".concat(name, ">") + (file ? " (".concat(file, ")") : '') : file || '';
};